<app-modal-basic #modalRelatorio modalContentId="relatorioMargemPorItemVendido" (closed)="onClose()">
  <div class="app-modal-header">
    <h4 class="modal-title">
      <i class="ti ti-file-text"></i> Margem de lucro por item vendido
      <button type="button" class="close basic-close" (click)="modalRelatorio.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </h4>
  </div>
  <div class="app-modal-body">
    <form [formGroup]="impressaoForm" (ngSubmit)="submitForm()">
      <div class="row">
        <div class="form-group col-sm-12">
          <label>Emissão</label>
          <div class="input-group">
            <app-data [calendarPosition]="'left'" formControlName="dataInicial"></app-data>
            <span class="input-group-addon">até</span>
            <app-data formControlName="dataFinal"></app-data>
          </div>
          <div class='row'>
            <div class='col-sm-6'>
              <show-errors [control]="impressaoForm.controls.dataInicial"></show-errors>
            </div>
            <div class='col-sm-6'>
              <show-errors [control]="impressaoForm.controls.dataFinal"></show-errors>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
            <app-combobox-produto
              #comboboxProduto
              [label]="'Produto'"
              class="form-group col-12"
              formControlName="itemId"
              appendTo="#relatorioMargemPorItemVendido">
            </app-combobox-produto>
      </div>

      <div class="row">
        <div class="form-group col-sm-12">
          <label>Número nota fiscal</label>
          <input digitOnly class="form-control" type="text" formControlName="numeroNf" style="text-align: left;"/>
          <show-errors [control]="impressaoForm.controls.numeroNf"></show-errors>
        </div>
      </div>

      <div class="row form-group col-sm-12">
            <div class="form-radio form-control" style="border: unset; padding-left: 0px;">
                <div class="radio radio-inline">
                    <label style="margin-bottom: 0px;">
                    <input type="radio" formControlName="formato" value='pdf'
                        [disableControl]="loading['disable'] || loading['request']">
                    <i class="helper"></i><span> PDF</span>
                    </label>
                </div>
                <div class="radio radio-inline">
                    <label style="margin-bottom: 0px;">
                    <input type="radio" formControlName="formato" value='xlsx'
                        [disableControl]="loading['disable'] || loading['request']">
                    <i class="helper"></i><span> XLSX</span>
                    </label>
                </div>
            </div>
      </div>

      <button type="submit" (click)="validaForm()" class="btn btn-primary ripple light" [disabled]="loading['imprimindo']">
        <app-loading [loading]="loading['imprimindo']" icone="icofont icofont-print" texto="Imprimir" textoLoading="Imprimindo..."/>
      </button>
      <button type="button" class="btn btn-danger ripple" (click)="modalRelatorio.hide()"><i class="ti ti-close"></i>
        Cancelar
      </button>
    </form>
  </div>
  <div class="app-modal-footer">

  </div>

</app-modal-basic>